const loadscript = (elementId: string, source: string): Promise<boolean> =>
    new Promise((resolve, reject) => {
        if (source) {
            if (document.getElementById(elementId)) {
                console.debug('Visualize.js already loaded')
                resolve(true)
            } else {
                const newScript = document.createElement('script')
                newScript.id = elementId
                newScript.async = false
                newScript.src = source
                document.body.appendChild(newScript)
                newScript.onload = () => {
                    console.debug('Visualize.js finished loading')
                    resolve(true)
                }
            }
        } else {
            reject(new Error('No Source Provided'))
        }
    })

export default loadscript
